import { allTrackers } from "app/services/track/track";

import createIndustryFilterEventsTrackingService from "./factory";

const industryFilterTrackingService = createIndustryFilterEventsTrackingService(
    allTrackers.dispatchTrackEvent.bind(allTrackers),
);

export default industryFilterTrackingService;
